<template>
  <div>
    <v-card
      style="min-height: 100vh;"
    >
      <v-toolbar
        dark
        flat
        dark
      >
        <v-icon
          left
        >
          edit
        </v-icon>
        Edit User
        <v-spacer />
        <v-btn
          fab
          flat
          dark
          @click="closeDialog"
        >
          x
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <Preloader v-if="loading"/>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs4
            style="text-align:center;margin-top:25px;"
          >
            <v-icon
              size="155"
              color="grey"
            >
              account_circle
            </v-icon>
            <div
              style="text-align:left;margin-top:25px;"
              class="details"
            >
              <span style="font-size:24px;">{{ edituser.first_name }} {{ edituser.last_name }}</span><br />
              <span><b>Username: </b>{{edituser.username}}</span><br />
              <span><b>E-mail: </b>{{edituser.email}}</span><br />
              <span><b>Date Created: </b>{{edituser.date_joined}}</span>
            </div>
          </v-flex>
          <v-flex
            xs8
          >
            <v-form ref="editForm">
              <v-container fluid>
              <v-card
                style="margin:15px;"
              >
                <v-toolbar
                  flat
                  dense
                >
                  Account Information
                </v-toolbar>
                <v-card-text>
                  <v-layout
                    row
                    wrap
                  >
                    <v-flex xs6>
                      <v-text-field
                        v-model="edituser.last_name"
                        autofocus
                        label="Last Name"
                      />
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="edituser.first_name"
                        label="First Name"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex>
                    <v-text-field
                      v-model="edituser.username"
                      :error-messages="errorMessages['username']"
                      :rules="[v => !!v || 'Username is required']"
                      label="Username"
                    />
                    </v-flex>
                  </v-layout>
                  <v-text-field
                    v-model="edituser.email"
                    :rules="[v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid']"
                    label="E-mail"
                  />
                  <v-text-field
                    v-model="edituser.phone"
                    :rules="edituser.phone ? [v => /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/.test(v) || 'Phone Number must match ###-###-####, ##########, ### ### #### or any equivalent format'] : []"
                    label="Mobile Phone"
                  />
                </v-card-text>
              </v-card>
              <v-card
                style="margin:15px;"
              >
                <v-toolbar
                  flat
                  dense
                >
                  Security
                  <v-spacer />
                  <v-btn
                    v-if="edituser.id"
                    color="#FFEA00"
                    @click="passwordReset=true"
                  >
                    Reset Password
                  </v-btn>
                </v-toolbar>
                <v-card-text
                  style="padding-top: 0;margin-top:0;"
                >
                  <v-switch
                    v-model="edituser.is_active"
                    hide-details
                    :label="`Enabled`"
                  ></v-switch>
                  <v-switch
                    v-model="edituser.is_org_admin"
                    messages="This grants a user access to your organization branding and user management."
                    :label="`Organization Administrator`"
                  ></v-switch>
                  <v-expand-transition>
                    <v-alert
                      v-if="edituser.role == null && !edituser.is_org_admin"
                      :value="true"
                      type="warning"
                      outline
                      style="margin-top: 15px;"
                    >
                      Users without a Role have No Access. Set a role to define the user's permissions.
                    </v-alert>
                  </v-expand-transition>
                  <v-autocomplete
                    v-model="edituser.role"
                    :disabled="edituser.is_org_admin"
                    :items="roles"
                    item-text="name"
                    item-value="id"
                    :search-input.sync="roleSearch"
                    label="Role"
                    cache-items
                    clearable
                    persistent-hint
                    :hint="edituser.is_org_admin ? 'To set a user role, disable admin permissions' : 'Set a role to define user permissions'"
                  />
                  <v-autocomplete
                    v-model="edituser.group"
                    :disabled="edituser.is_org_admin"
                    :items="groups"
                    item-text="name"
                    item-value="id"
                    :search-input.sync="groupSearch"
                    label="Security Group"
                    cache-items
                    clearable
                    persistent-hint
                    :hint="edituser.is_org_admin ? 'To set a security group, you disable admin permissions.' : 'Set a security group to limit this user to specific case types'"
                  />
                  <v-btn
                    @click="showTokenDialog = true; getAPIToken()"
                    style="margin-top: 10px; margin-right: 5px"
                  >
                    Show API Token
                  </v-btn>
                </v-card-text>
              </v-card>
              <v-card
                v-if="edituser.id"
                style="margin:15px;"
              >
                <v-toolbar
                  flat
                  dense
                >
                  Notification Preferences
                  <span style="font-weight:700;">
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-if="tagStatus === 'saving'">
                      Saving Preferences...
                    </span>
                    <span v-if="tagStatus === 'saved'">
                      Preferences Saved!
                    </span>
                    <span v-if="tagStatus === 'error'">
                      !! Something went wrong !!
                    </span>
                  </span>
                </v-toolbar>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm4>
                      <span>How would you like to receive notifications?</span>
                    </v-flex>
                    <v-flex xs12 sm4>
                      <v-switch
                        v-model="edituser.notify_by_email"
                        style="display:inline;text-align:center;"
                        label="Via E-mail"
                        :hint="edituser.email"
                        persistent-hint
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm4>
                    <!--
                      <v-switch
                        v-model="edituser.notify_by_phone"
                        style="display:inline;"
                        label="Via SMS"
                        :hint="edituser.phone"
                        persistent-hint
                      ></v-switch>
                    -->
                    </v-flex>
                  </v-layout>
                  <br />
                  <hr />
                  <br />
                  <p style="font-weight:500;font-size:18px;">Form Subscriptions</p>
                  <div
                    v-for="tag in formTagSubs"
                    :key="tag.slug"
                  >
                    <v-layout row wrap>
                      <v-flex xs12 sm3>
                        <v-chip
                          label
                          small
                        >
                          {{tag.tag}}
                        </v-chip>
                        <span>
                          <v-icon
                            small
                            right
                            @click="deleteFormSub(tag)"
                          >
                            delete_forever
                          </v-icon>
                        </span>
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-switch
                          v-model="tag.on_client_start"
                          style="display:inline;"
                          label="On Client Start"
                          @change="updateFormTag(tag)"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-switch
                          v-model="tag.on_client_submit"
                          style="display:inline;"
                          label="On Client Submission"
                          @change="updateFormTag(tag)"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 sm3>
                        <v-switch
                          v-model="tag.on_client_sign"
                          style="display:inline;"
                          label="On Client Signing"
                          @change="updateFormTag(tag)"
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </div>
                  <v-btn
                    small
                    v-if="!addFormTag"
                    @click="addFormTag = true"
                  >
                    <v-icon small left>add</v-icon>
                    Add Form Subscription
                  </v-btn>
                  <v-expand-transition>
                    <div v-if="addFormTag">
                      <v-autocomplete
                        v-model="filterFormTags"
                        :items="tagFormResults"
                        :search-input.sync="tagFormSearch"
                        label="Search for a Tag"
                        dense
                        return-object
                        item-text="tag"
                        auto-select-first
                        hide-details
                      />
                    </div>
                  </v-expand-transition>
                  <br />
                  <br />
                  <p style="font-weight:500;font-size:18px;">Contact Subscriptions</p>
                  <div
                    v-for="tag in contactTagSubs"
                    :key="tag.slug"
                  >
                    <v-layout row wrap>
                      <v-flex xs12 sm4>
                        <v-chip
                          label
                          small
                        >
                          {{tag.tag}}
                        </v-chip>
                        <span>
                          <v-icon
                            small
                            right
                            @click="deleteContactSub(tag)"
                          >
                            delete_forever
                          </v-icon>
                        </span>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-switch
                          v-model="tag.on_client_file_upload"
                          style="display:inline;"
                          label="On Client File Upload"
                          @change="updateContactTag(tag)"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-switch
                          v-model="tag.on_client_message"
                          style="display:inline;"
                          label="On Client Communication"
                          @change="updateContactTag(tag)"
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </div>
                  <v-btn
                    small
                    v-if="!addContactTag"
                    @click="addContactTag = true"
                  >
                    <v-icon small left>add</v-icon>
                    Add Contact Subscription
                  </v-btn>
                  <v-expand-transition>
                    <div v-if="addContactTag">
                      <v-autocomplete
                        v-model="filterContactTags"
                        :items="tagContactResults"
                        :search-input.sync="tagContactSearch"
                        label="Search for a Tag"
                        dense
                        return-object
                        item-text="tag"
                        auto-select-first
                        hide-details
                      />
                    </div>
                  </v-expand-transition>
                </v-card-text>
              </v-card>
              <v-card
                v-if="!edituser.id && editing"
                style="margin:15px;"
              >
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex>
                      <v-text-field
                        v-model="edituser.password"
                        :error-messages="errorMessages['password']"
                        :rules="[v => !!v || 'Password is required']"
                        type="password"
                        label="Temporary Password"
                        autocomplete="new-password"
                      />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="saving"
          flat
          color="gray"
          @click="closeDialog">
          Cancel
        </v-btn>
        <v-btn
          :disabled="saving"
          flat
          color="blue"
          @click="save(edituser)">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="passwordReset"
      width="400"
      transition="dialog-fade-transition"
    >
      <v-toolbar
        flat
        color="gray"
        dense
      >
        Password Reset
      </v-toolbar>
      <v-card
        v-show="passwordSaved"
        color="#FDFDFD"
      >
        <v-card-text style="text-align:center;">
          The user's new password is: <code>{{newPassword}}</code><br />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="passwordReset = false; newPassword = null; passwordSaved = false">OK</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
      <v-card
        v-show="!passwordSaved"
        color="#FDFDFD"
      >
        <v-card-text style="text-align:center;">
          <span>Set a password below, or click 'Generate Random Password' to set a random password.</span>
          <v-text-field
            v-model="newPassword"
            label="Set New Password"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            v-if="!newPassword"
            color="red"
            dark
            @click="resetPassword()"
          >
            Generate Random Password
          </v-btn>
          <v-btn
            v-if="newPassword"
            color="blue"
            dark
            @click="resetPassword()"
          >
            Set Password
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showTokenDialog"
      width="400"
      transition="dialog-fade-transition"
    >
      <v-toolbar
        flat
        color="gray"
        dense
      >
        Users API Token
      </v-toolbar>
      <v-card
        style="text-align:center;"
      >
        <v-card-text>
          The users API token is <br/> <code>{{ APIToken }}</code>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            @click="resetAPIToken"
          >
            Reset Token
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import Preloader from '@/components/global/Preloader'

export default {
  name: 'User',
  props: [ 'user' ],
  components: {
    Preloader
  },
  data () {
    return {
      edituser: {},
      editing: true,
      loading: false,
      errorMessages: [],
      saving: false,
      newPassword: '',
      passwordReset: false,
      passwordSaved: false,
      formTagSubs: [],
      contactTagSubs: [],
      tagStatus: '',
      addFormTag: false,
      addContactTag: false,
      filterContactTags: null,
      filterFormTags: null,
      tagFormSearch: null,
      tagContactSearch: null,
      tagSearchStorage: [],
      groups: [],
      groupSearch: '',
      roleSearch: '',
      roles: [],
      showTokenDialog: false,
      APIToken: ''
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.$route.params.id = to.params.id
    this.fetch()
    next()
  },
  computed: {
    tagFormResults () {
      return this.tagSearchStorage.filter(object => {
        var exists = false
        this.formTagSubs.forEach(tagObject => {
          if (tagObject.tag === object) {
            exists = true
          }
        })
        if (!exists) {
          return object
        }
      })
    },
    tagContactResults () {
      return this.tagSearchStorage.filter(object => {
        var exists = false
        this.contactTagSubs.forEach(tagObject => {
          if (tagObject.tag === object) {
            exists = true
          }
        })
        if (!exists) {
          return object
        }
      })
    }
  },
  watch: {
    user () {
      if (this.user) {
        this.fetch()
      } else {
        this.edituser = {}
      }
    },
    groupSearch () {
      if (this.groupSearch && this.groupSearch !== "") {
        this.fetchGroups(this.groupSearch)
      }
    },
    tagContactSearch () {
      if (this.tagContactSearch) {
        this.fetchContactTags()
      }
    },
    tagFormSearch () {
      if (this.tagFormSearch) {
        this.fetchFormTags()
      }
    },
    filterFormTags () {
      this.addFormTag = false
      if (this.filterFormTags !== null) {
        this.formTagSubs.push(this.filterFormTags)
        this.tagFormSearch = null
        this.tagSearchStorage = []
        this.filterFormTags = null
      }
    },
    filterContactTags () {
      this.addContactTag = false
      if (this.filterContactTags !== null) {
        this.contactTagSubs.push(this.filterContactTags)
        this.tagContactSearch = null
        this.tagSearchStorage = []
        this.filterContactTags = null
      }
    },
    roleSearch () {
      if (this.roleSearch && this.roleSearch !== "") {
        this.fetchRoles(this.roleSearch)
      }
    }
  },
  methods: {
    fetch () {
      this.loading = true
      api.users.user.get(this.user)
        .then(user => {
          this.documentTitle('User > ' + user.username)
          this.edituser = user
          this.loading = false
          api.userform.adminUserformTags.getSubs(user.id)
            .then(formTags => {
              this.formTagSubs = formTags
            })
          api.userform.adminContactTags.getSubs(user.id)
            .then(contactTags => {
              this.contactTagSubs = contactTags
            })
          if (this.edituser.group)
            api.users.groups.get(this.edituser.group)
              .then((data) => {
                this.groups = [data]
              })
          if (this.edituser.role)
            api.users.roles.get(this.edituser.role)
              .then((data) => {
                this.roles = [data]
              })
        })
    },
    fetchRoles (search) {
      api.users.roles.list({
        search: search
      })
      .then((data) => {
        this.roles = data['results']
      })
    },
    resetPassword () {
      api.users.user.resetPassword(this.edituser.id, this.newPassword)
        .then(user => {
          this.loading = false
          this.passwordReset = true
          this.passwordSaved = true
          this.newPassword = user.password
        })
      this.loading = true
    },
    fetchGroups (search) {
      api.users.groups.list({
        search: search
      })
      .then((data) => {
        this.groups = data['results']
      })
    },
    toggleUser () {
      this.loading = true
      this.edituser.is_active = !this.edituser.is_active
      api.users.user.save(this.edituser)
        .then(user => {
          this.loading = false
          this.edituser = user
        })
    },
    save () {
      if (this.$refs.editForm.validate()) {
        this.loading = true
        this.errorMessages = []
        if (!this.edituser.group || this.edituser.is_org_admin)
          this.edituser.group = null
        if (!this.edituser.role)
          this.edituser.role = null
        api.users.user.save(this.edituser, [400])
          .then(user => {
            this.loading = false
            if (!this.edituser.id) {
              this.edituser = user
            } else {
              this.closeDialog()
            }
          })
          .catch(error => {
            this.loading = false
            this.saving = false
            if (error.response.status === 400) {
              this.errorMessages = JSON.parse(error.request.response)
            }
          })
      }
    },
    updateFormTag (tag) {
      this.tagStatus = 'saving'
      api.userform.adminUserformTags.updateSub(this.edituser.id, tag)
        .then(() => {
          this.tagStatus = 'saved'
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    deleteFormSub (tag) {
      this.tagStatus = 'saving'
      api.userform.adminUserformTags.deleteSub(this.edituser.id, tag)
        .then(() => {
          this.tagStatus = 'saved'
          this.formTagSubs = this.formTagSubs.filter((oldTag) => {
            if (oldTag !== tag) {
              return oldTag
            }
          })
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    updateContactTag (tag) {
      this.tagStatus = 'saving'
      api.userform.adminContactTags.updateSub(this.edituser.id, tag)
        .then(() => {
          this.tagStatus = 'saved'
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    deleteContactSub (tag) {
      this.tagStatus = 'saving'
      api.userform.adminContactTags.deleteSub(this.edituser.id, tag)
        .then(() => {
          this.tagStatus = 'saved'
          this.contactTagSubs = this.contactTagSubs.filter((oldTag) => {
            if (oldTag !== tag) {
              return oldTag
            }
          })
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    fetchFormTags () {
      api.userform.userformTags.get(this.tagFormSearch)
        .then(tagResults => {
          this.tagSearchStorage = tagResults
        })
    },
    fetchContactTags () {
      api.userform.contactTags.get(this.tagContactSearch)
        .then(tagResults => {
          this.tagSearchStorage = tagResults
        })
    },
    closeDialog () {
      this.$emit('update:editing', false)
      this.edituser = {}
    },
    getAPIToken() {
      api.users.user.getAPIToken(this.edituser.id)
        .then(tokenResult => {
          this.APIToken = tokenResult.token
        })
    },
    resetAPIToken() {
      api.users.user.resetAPIToken(this.edituser.id)
        .then(tokenResult => {
          this.APIToken = tokenResult.token
        })
    }
  }
}
</script>

<style>

.right-held {
  right:0;
  left: unset !important;
  max-width: 1200px;
  bottom: 0;
  min-height: 100vh;
}

</style>
